import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Dice1 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function SlotMachineCard() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Card>
      <CardHeader className='pb-3'>
        <div className='flex items-center gap-2'>
          <Dice1 className='h-5 w-5 text-purple-500' />
          <CardTitle className='text-sm'>{t('Slot Machine')}</CardTitle>
        </div>
        <CardDescription className='text-xs'>{t('Try your luck and win quota rewards')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          className='w-full'
          variant='outline'
          size='sm'
          onClick={() => navigate({ to: '/slot-machine' })}
        >
          {t('Spin now')}
        </Button>
      </CardContent>
    </Card>
  )
}
